import { Injectable } from '@angular/core';
import { ServiceRelations } from '../../domain/models/service-relations.model';
import { ServiceRelationsApiDTO, ServiceRelationsStorageDTO } from '../dto/relation.api.dto';

@Injectable({ providedIn: 'root' })
export class ServiceRelationsMapper {
  fromApiToDomain(dto: ServiceRelationsApiDTO): ServiceRelations {
    return {
      locationsToCashDrawers: dto.locationsToCashDrawers,
      cashDrawersToWorkers: dto.cashDrawersToWorkers,
      workersToLocations: dto.workersToLocations,
    };
  }

  fromDomainToApi(domain: ServiceRelations): ServiceRelationsApiDTO {
    return {
      locationsToCashDrawers: domain.locationsToCashDrawers,
      cashDrawersToWorkers: domain.cashDrawersToWorkers,
      workersToLocations: domain.workersToLocations,
    };
  }

  /**
   * Converts API DTO to storage DTO (same structure, no wrapper)
   */
  fromApiToStorage(dto: ServiceRelationsApiDTO): ServiceRelationsStorageDTO {
    return {
      locationsToCashDrawers: dto.locationsToCashDrawers,
      cashDrawersToWorkers: dto.cashDrawersToWorkers,
      workersToLocations: dto.workersToLocations,
    };
  }

  fromStorageToDomain(dto: ServiceRelationsStorageDTO): ServiceRelations {
    return {
      locationsToCashDrawers: dto.locationsToCashDrawers,
      cashDrawersToWorkers: dto.cashDrawersToWorkers,
      workersToLocations: dto.workersToLocations,
    };
  }
}

